import React,{useRef,useState}  from "react";
import { Text, View,  TouchableOpacity,  Image} from "react-native";
import { CreateResponsiveStyle,DEVICE_SIZES,maxSize} from "rn-responsive-styles";
import CView from "./CView";
import CText from "./CText";
import QRCode from 'qrcode.react';
import html2canvas from 'html2canvas';
export default function CQrCodeModal(props) {
  const contentRef = useRef(null);
  const styles = useStyles();
  const vrn  =  props?.data?.vrn;
  const qrCodeUrl = props?.data?.qrCodeUrl;
  const qrRef = useRef(null)
  
  // Function to handle download
  const downloadQRCode = () =>  {
    html2canvas(contentRef.current).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.download = 'qrCode.png';
      link.href = imgData;
      link.click();
    });
  };

  const onPressActionButton = () => {
    props.onCloseModal();
  };
  return (
    <View style={styles.container}>
      <View style={styles.overlay}>
        <View style={styles.loaderBg}>
        <View ref={contentRef} style={styles.overlay}>
        <CView MT={50} >
         
        <CText.cancelPolicyConfirmText>{'Here’s your recharge code!'}</CText.cancelPolicyConfirmText>
        </CView>
          <CView MT={20} >
          <CText.srDate>{'Scan this QR code from any UPI app to \nrecharge your FASTag '}</CText.srDate>
          </CView>
          <CView MT={20} >

          <Image
            source={require('../assets/images/IDFC_logo_2.png')}
            style={styles.Header_IDFCLogo}
          />
          </CView>

          
          <CView MT={20} ref={qrRef} >
           
             
       <QRCode id="qrcode" value={qrCodeUrl} />
          </CView>
          
          <CView  FR  MT={10} >
          <Text style={[styles.text]}>{'Vehicle no. :'}</Text>
          <Text style={styles.text}>{vrn}</Text>
          </CView>
          </View>
          <View style={styles.footer}>
              <TouchableOpacity onPress={() => downloadQRCode()} style={styles.footerBtn} >
                <Text style={styles.footerLink}> {"Save To Gallery"}</Text>
              </TouchableOpacity>
            </View>
        </View>
       
        <TouchableOpacity onPress={onPressActionButton}>
        <CView MT={10}>
        <CText.checkTagSubmitStyle>Dismiss</CText.checkTagSubmitStyle>   
        </CView></TouchableOpacity>
      </View>
    </View>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    Header_IDFCLogo: {
        width: 90,
        height: 33,
        marginRight: 30,
        marginLeft: 24,
},
  container: {
     position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 99999, 
  },
  overlay: {
   width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  loaderBg: {
    padding:10,
    backgroundColor: "white",
    width: 390,
    height: 450,
    borderRadius: 20,
    justifyContent: "center",
    alignItems: "center",
    display:"flex",
    flexDirection:"column",
    shadowColor: "rgba(0,0,0,0.05)",
    shadowOpacity: 1.5,
    elevation: 12,
    shadowRadius: 20,
    shadowOffset: { width: 1, height: 13 },
  },
  iconSuccess: {
    marginVertical: 15,
    width: 38,
    height: 38,
  },
  iconError: {
    marginVertical: 15,
    width: 45,
    height: 42,
  },
  title: {
    color: "#5a5755",
    fontFamily: "Inter",
    fontSize: 18,
    alignSelf: "center",
    marginTop: 25,
  },
  text: {
    color: "#02122c",
    fontFamily: "Inter",
    fontSize: 11,
    fontWeight: 600,
    alignSelf: "center",
    marginBottom: 10,
    textAlign:"center",
    paddingHorizontal:15
  },
  footer: {
    width: "100%",
    bottom: 20,
    paddingVertical: 10,
    alignItems: "center",
  },
  footerBtn: {
    width: "auto",
    height: 30.5,
    borderRadius: 16,
    borderColor: "#9d1d27",
    borderWidth: 1,
    paddingVertical: 5,
    paddingHorizontal: 20,
    alignItems: "center",
    backgroundColor:"#9d1d27"
  },
  footerLink: {
    fontFamily: "Inter",
    fontSize: 11,
    fontWeight: "bold",
    fontStyle: "normal",
    letterSpacing: -0.22,
    textAlign: "left",
    color: "white",
    alignSelf:"center",
    paddingTop:2
  },
},
{
  [maxSize(DEVICE_SIZES.XS)]: {
    loaderBg: {
      backgroundColor: "white",
      width: "90%",
      height: 290,
      borderRadius: 20,
      justifyContent: "flex-start",
      alignItems: "center",
      shadowColor: "rgba(0,0,0,0.05)",
      shadowOpacity: 1.5,
      elevation: 12,
      shadowRadius: 20,
      shadowOffset: { width: 1, height: 13 },
    },
     overlay: {
    width: "100%",
    height: "100%",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop:"30%"
  },
  loaderBg:{
    height:430,
    width:"85%"
  },
  footer: {
    width: "100%",
    bottom: 70,
    paddingVertical: 10,
    alignItems: "center",
  },
  footerBtn: {
    width: "auto",
    height: 30.5,
    borderRadius: 16,
    borderColor: "#9d1d27",
    borderWidth: 1,
    paddingVertical: 5,
    paddingHorizontal: 20,
    alignItems: "center",
    backgroundColor:"#9d1d27"
  },
  },
});
